import React from 'react';
import './NotFound.css';

const NotFoundPage = () => (
  <div className='notFound'>
    <h3>The page you are trying to access does not exist.</h3> 
  </div>
);

export default NotFoundPage;


// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.js